import { Component } from '@angular/core';

@Component({
    selector: 'tk-common-placeholder',
    styleUrls: ['./common-placeholder.component.less'],
    templateUrl: './common-placeholder.component.html'
})
export class CommonPlaceholderComponent {
}
